import React from 'react';

interface Props {
  color?: string;
  fontSize?: number | string;
}

const Dash: React.FC<Props> = ({ color = 'inherit', fontSize = 'inherit' }) => {
  return (
    <svg
      role="img"
      width="1em"
      height="1em"
      style={{ fontSize: typeof fontSize === 'string' ? fontSize : `${fontSize}px`, color }}
      viewBox="0 0 18 18"
    >
      <g id="Group_7565" data-name="Group 7565" transform="translate(0.344 0)">
        <circle
          id="Ellipse_33"
          data-name="Ellipse 33"
          cx="3.5"
          cy="3.5"
          r="3.5"
          transform="translate(-0.344 0)"
          fill="currentColor"
        />
        <circle
          id="Ellipse_36"
          data-name="Ellipse 36"
          cx="3.5"
          cy="3.5"
          r="3.5"
          transform="translate(-0.344 11)"
          fill="currentColor"
        />
        <circle
          id="Ellipse_34"
          data-name="Ellipse 34"
          cx="3.5"
          cy="3.5"
          r="3.5"
          transform="translate(10.656 0)"
          fill="currentColor"
        />
        <circle
          id="Ellipse_35"
          data-name="Ellipse 35"
          cx="3.5"
          cy="3.5"
          r="3.5"
          transform="translate(10.656 11)"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export default Dash;
